/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentSharedParcelEnums200,
  GetApiV1IndividualpaymentSharedParcelEnums401,
  GetApiV1IndividualpaymentSharedParcelEnums500,
  GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedParcelEnums.ts";
import { individualPaymentParcelEnumsViewModelSchema } from "../individualPaymentParcelEnumsViewModelSchema.ts";

export const getApiV1IndividualpaymentSharedParcelEnumsQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentSharedParcelEnumsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentSharedParcelEnums200Schema = z.lazy(
  () => individualPaymentParcelEnumsViewModelSchema,
) as unknown as ToZod<GetApiV1IndividualpaymentSharedParcelEnums200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentSharedParcelEnums401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedParcelEnums401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentSharedParcelEnums500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedParcelEnums500>;

export const getApiV1IndividualpaymentSharedParcelEnumsQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentSharedParcelEnums200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse>;
